import * as React from "react";
import { GameState } from "../GameState";
export const MiniGameStateWrapper = (props) => !props.details.hideGameState
    ? React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__clock`, "data-uat": `div-ev-list-${props.componentPrefix}-clock` },
        React.createElement(GameState, { details: props.details, componentPrefix: props.componentPrefix }))
    : React.createElement(React.Fragment, null);
//# sourceMappingURL=MiniGameStateWrapper.js.map